import React, { useEffect } from 'react';
import { Link, useNavigate, useOutletContext } from 'react-router-dom';
import { API_URL } from '../../config/constants';
import axios from 'axios';

function ShowMyData(props) {
    const { myInfo, userRanks } = useOutletContext();
    const navigate = useNavigate();
    const onBack = e => {
        e.preventDefault();
        navigate('/home/data/sumData');
    };

    async function exportCryptoKey(key, type) {
        // 1. CryptoKey를 spki(공개키) 또는 pkcs8(개인키) 포맷의 ArrayBuffer로 export
        const format = type === "PUBLIC KEY" ? "spki" : "pkcs8";
        const exported = await window.crypto.subtle.exportKey(format, key);

        // 2. ArrayBuffer를 Base64 문자열로 변환
        const byteArray = new Uint8Array(exported);
        let binaryString = "";
        for (let i = 0; i < byteArray.byteLength; i++) {
            binaryString += String.fromCharCode(byteArray[i]);
        }
        const base64 = window.btoa(binaryString);

        // 3. 64자마다 줄바꿈(\n) 처리하여 PEM 표준 규격으로 포맷팅
        const pemBody = base64.match(/.{1,64}/g).join("\n");
        const pem = `-----BEGIN ${type}-----\n${pemBody}\n-----END ${type}-----`;

        return pem;
    }

    // 웹 브라우저에서 실행되는 자바스크립트 함수
    async function generateAndRegisterKeys(e) {
        e.preventDefault();
        try {
            console.log("🔑 브라우저 내부에서 RSA 키 생성 중...");

            // 1. 브라우저 내장 Web Crypto API로 RSA 키 쌍 생성
            const keyPair = await window.crypto.subtle.generateKey(
                {
                    name: "RSASSA-PKCS1-v1_5",
                    modulusLength: 2048,
                    publicExponent: new Uint8Array([1, 0, 1]),
                    hash: "SHA-256",
                },
                true, // export 가능 여부
                ["sign", "verify"]
            );

            // 2. 키를 PEM 텍스트 포맷으로 변환 (Export)
            const privatePem = await exportCryptoKey(keyPair.privateKey, "PRIVATE KEY");
            const publicPem = await exportCryptoKey(keyPair.publicKey, "PUBLIC KEY");

            // 3. public.pem은 API 서버로 전송하여 등록
            const result = await axios.post(`${API_URL}/export/registerPubKey`, {
                userEmail: myInfo.userEmail,
                publicKey: publicPem
            });

            const { success } = result.data;

            if (success) {

                // 4. private.pem은 브라우저에서 파일로 즉시 다운로드 처리
                downloadFile(privatePem, "private.pem");

                alert("키 발급 및 등록이 완료되었습니다. 다운로드된 private.pem을 추출프로그램 폴더에 넣으세요!");
            } else {
                alert("키 등록에 실패했습니다. 잠시 후 다시 시도해주세요.")
            }


        } catch (err) {
            console.error("키 생성 실패:", err);
        }
    }

    // 헬퍼: 브라우저에서 텍스트 파일 바로 다운로드하게 만드는 함수
    function downloadFile(content, fileName) {
        const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = fileName;
        link.style.display = 'none';

        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }, 100);
    }

    async function onMakeKeys(e) {
        e.preventDefault();

        await axios.post(`${API_URL}/export/registerPubKey`, {
            userEmail: myInfo.userEmail,
            publicKey: 'test'
        })
    }
    const myRank = userRanks.find(el => el.rankId === myInfo.rankId);
    return (
        <div className='myInfo'>
            <p className='path'>내정보</p>
            <h2 className='pageTitle'>내 정보</h2>
            <div className='pageContent'>
                <div className='myInfoTblArea'>
                    <Link className='editMyInfoBtn' to={'/home/mypage/edit'}>내 정보 수정</Link>
                    <table className='myInfoTbl'>
                        <tbody>
                            <tr>
                                <td className='labelTd'>
                                    E-mail
                                </td>
                                <td className='infoTd'>
                                    {
                                        myInfo.userEmail
                                    }
                                </td>
                            </tr>
                            <tr style={{ height: '31px' }} />
                            <tr>
                                <td className='labelTd'>
                                    비밀번호
                                </td>
                                <td className='infoTd'>
                                    ************
                                </td>
                            </tr>
                            <tr style={{ height: '31px' }} />
                            <tr>
                                <td className='labelTd'>
                                    이　름
                                </td>
                                <td className='infoTd'>
                                    {
                                        myInfo.userName
                                    }
                                </td>
                            </tr>
                            <tr style={{ height: '31px' }} />
                            <tr>
                                <td className='labelTd'>
                                    소　속
                                </td>
                                <td className='infoTd'>
                                    {
                                        myInfo.Organization.name
                                    }
                                </td>
                            </tr>
                            <tr style={{ height: '31px' }} />
                            <tr>
                                <td className='labelTd'>
                                    사용 권한
                                </td>
                                <td className='infoTd'>
                                    {`${myRank.name}`}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className='btnsArea'>
                        {/* <a href={`https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${process.env.REACT_APP_NAVER_ID}&redirect_uri=${API_URL}/monitoring-manage/linkAccountToNaver?userEmail=${myData.userEmail}`}>네이버 연동</a> */}
                        <button className='exportKeyBtn' onClick={generateAndRegisterKeys}>키 파일 발급</button>
                        <button className='backBtn' onClick={onBack}>돌아가기</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ShowMyData;